import { Component, OnInit, ChangeDetectorRef, AfterViewInit, ElementRef, ViewChild, Renderer2, Inject, PLATFORM_ID } from '@angular/core';

import { ActivatedRoute, Params, Router } from '@angular/router';
//import {DomSanitizer} from '@angular/platform-browser';
import { ContentService } from './services/content.service';
//import { StorageService } from '@citi-gcg-173875/citi-utils';
import { SvcServices, PopupModalService, windowService } from './services';
import { DmarService } from './services/dmar.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { styleConfig } from './app.styleConfig';
import { take, catchError, finalize } from 'rxjs/operators';
import { EMPTY, from } from 'rxjs';
import { E2eService } from './services/e2e.service';
import { BackendService } from './services/backend.service';
import { ScriptLoaderService } from './services/script-loader.service';
import { resolveLangParams } from './utils/lang.util';
import { Title } from '@angular/platform-browser';
@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

  constructor(
    private _route: ActivatedRoute,
    private router: Router,
    private _contentService: ContentService,
    private _svcService: SvcServices,
    private windowService: windowService,
    private _e2eService: E2eService,
    private backend: BackendService,
    private _changeDect: ChangeDetectorRef,
    private scriptLoader: ScriptLoaderService,
    private _dmarService: DmarService,
    private popupModalService: PopupModalService,
    //private _storageService: StorageService,
    private el: ElementRef,
    private _renderer: Renderer2,
    @Inject(DOCUMENT) private document,
    @Inject(PLATFORM_ID) private platformId: string,
    private title: Title
  ) { }

  branding: any;
  modalData: any;
  loaded: boolean = false;
  isShown: boolean = false;
  siteId: any;
  pageData: any;
  isBrowserSupportPage: boolean = false;
  ifBookmarkEnabled: any;
  showBrandValue: any;
  dynamicScripts = [];
  private _isSywSignon = false;
  private _isSsoAuthenticateRedirect = false;
   _hideSignonUI = false;

  setStylesheet(qParams) {
    this.siteId = qParams.siteId.toLowerCase();
      for (var j = 0; j < styleConfig.partnerEnv.length; j++) {
        if (this.siteId == styleConfig.partnerEnv[j].siteId.toLowerCase()) {
          let a = this.document.getElementById('partnerStylesheet');
          let b = this.document.getElementById('partnerIcon');
          if(this.router.url.startsWith("/supported-browsers")){
            this._renderer.setAttribute(a, 'href', 'assets/uicontainerBuild/css/' + styleConfig.partnerEnv[j].styleName + '/' + styleConfig.partnerEnv[j].styleName + '.css');
          } else {
            this._renderer.setAttribute(a, 'href', 'assets/css/' + styleConfig.partnerEnv[j].styleName + '/' + styleConfig.partnerEnv[j].styleName + '.css');
          }
         }
      }
  }

  @ViewChild('overlay') overlay: ElementRef;
  ngOnInit() {
    let siteIdVar = '';
    let brandIdVar = '';

    console.log(this._svcService.api, "api");

    this.initGptScript();
    this.deleteCookies();
    sessionStorage.removeItem('selectedCardAccountUUID');

    this._route.queryParams.subscribe((qParam: Params) => {
      if (Object.keys(qParam).length === 0) return;

      this.isBrowserSupportPage = this.router.url.startsWith("/supported-browsers");
      const { siteLocale, lang } = resolveLangParams(qParam);
      localStorage.setItem('siteLocal_ID', siteLocale);
      document.documentElement.setAttribute('lang', lang);

      brandIdVar = this.updateBrandId(qParam, brandIdVar);
      siteIdVar = qParam?.siteId?.toLowerCase();
      console.log('Updated siteId:', siteIdVar);

      this._svcService.setParams(qParam);
      this._contentService.setParams(qParam);

      const pageName = qParam?.pageName;
      this.title.setTitle(pageName ? `Citi Retail Services - ${pageName}` : 'Citi Retail Services');

      console.log("appcomp before-->_hideSignonUI value:", this._hideSignonUI);
      this.handlePageAction(qParam);
      this.validateAndNavigate(qParam);
      this.subscribeToBrandingContent(qParam, siteIdVar, brandIdVar);
      // ssologin and tyRewardsSignon manage their own routing and UI - match original early-return behavior
      if (qParam.pageName === 'ssologin' || qParam.pageName === 'tyRewardsSignon') return;
      this.subscribeToSignOnLoaded();

      if (qParam?.siteId?.toLowerCase() === 'plcn_syw' && qParam?.pageName?.toLowerCase() === 'signon') {
        this._isSywSignon = true;
      }
    });
  }

  private initGptScript(): void {
    if (typeof window !== 'undefined') {
      this.scriptLoader
        .loadScript('https://securepubads.g.doubleclick.net/tag/js/gpt.js')
        .then(() => { console.log('GPT script loaded successfully'); })
        .catch((error) => { console.error(error); });
    }
  }

  private updateBrandId(qParam: Params, brandIdVar: string): string {
    if (qParam?.brandId) {
      const newBrandId = qParam.brandId.toLowerCase();
      if (this.showBrandValue !== newBrandId) {
        console.log('BrandId changed from', this.showBrandValue, 'to', newBrandId);
        this.showBrandValue = newBrandId;
        this._contentService.clearCache();
        this._svcService.clearCache();
        this._svcService.setParams(qParam);
        this._contentService.setParams(qParam);
      }
      return this.showBrandValue;
    }
    this.showBrandValue = '';
    return this.showBrandValue;
  }

  private handlePageAction(qParam: Params): void {
    const pageName = qParam.pageName;
    const ssopartner = ['plcn_bestbuy', 'plcn_homedepot'];

    if (pageName === 'ssoauthenticate' && !!qParam.partnerUserId
        && ssopartner.includes(qParam?.siteId?.toLowerCase())) {
      this.handleSsoAuthenticatePartner(qParam);
    } else if (pageName === 'ssoauthenticate' && !!qParam.partnerUserId && !!qParam.request_uri
        && qParam?.siteId?.toLowerCase() === 'plcn_dillards') {
      this.handleSsoAuthenticateDillards();
    } else if (pageName === 'ssoauthorize' && !!qParam.processIndicator && !!qParam.siteId && !!qParam.token) {
      this.handleSsoAuthorize(qParam);
    } else if (pageName === 'ssologin') {
      this._renderer.removeChild(this, this.overlay.nativeElement);
    } else if (pageName === 'tyRewardsSignon') {
      this.setStylesheet(qParam);
      this._renderer.removeChild(this, this.overlay.nativeElement);
    } else if (pageName?.toLowerCase() === 'signon' || pageName?.toLowerCase() === 'singlesignon') {
      this.handleSignonPage();
    }
  }

  private handleSsoAuthenticatePartner(qParam: Params): void {
    sessionStorage.setItem("ssoPartnerUserId", qParam.partnerUserId);
    sessionStorage.setItem("ssoPartnerRedirectUrl", qParam.partnerRedirectUrl);
    sessionStorage.setItem("ssoState", qParam.state);
    this._isSsoAuthenticateRedirect = true;
    this._hideSignonUI = true;
    console.log("appcomp after-->_hideSignonUI value:", this._hideSignonUI);
    const redirectUrl = `${window.location.origin}/RSauth/signon?pageName=singlesignon&siteId=${qParam.siteId}&langId=en_US`;
    window.location.href = redirectUrl;
  }

  private handleSsoAuthenticateDillards(): void {
    this._hideSignonUI = true;
    this.backend.delete("logout", {}, {})
      .pipe(catchError((error) => { this._hideSignonUI = false; return from([{ error }]); }))
      .subscribe(() => {
        console.log("app component pagename ssoauthenticate start");
        this._svcService.getAuthorizeToken().subscribe(() => { });
        console.log("app component pagename ssoauthenticate end");
      });
  }

  private handleSsoAuthorize(qParam: Params): void {
    this._hideSignonUI = true;
    if (localStorage.getItem('sso_authorize_in_progress') === 'true') {
      this.router.navigate(['/signon'], {
        queryParams: { pageName: 'signon', siteId: qParam.siteId, langId: qParam.langId ?? 'en_US', cmp: qParam.cmp, multitab: 'true' }
      });
      return;
    }
    localStorage.setItem('sso_authorize_in_progress', 'true');
    try {
      const allowedPartners = ['PLCN_BESTBUY', 'PLCN_LLBEAN', 'PLCN_DILLARDS', 'PLCN_CTY'];
      if (allowedPartners.includes(qParam?.siteId?.toUpperCase())) {
        this.backend.delete("logout", {}, {})
          .pipe(finalize(() => { this.SSOAuthorizeSetup(qParam.processIndicator, qParam.siteId, qParam.token, qParam.cmp); }))
          .subscribe({
            next: (data) => console.log("Logout successful:", data),
            error: (error) => console.error("Logout failed, proceeding with SSO setup:", error)
          });
      } else {
        localStorage.removeItem('sso_authorize_in_progress');
        this.redirectToSignOn();
      }
    } catch (error) {
      console.error('Error in SSOAuthorize flow:', error);
      localStorage.removeItem('sso_authorize_in_progress');
      this.redirectToSignOn();
    }
  }

  private handleSignonPage(): void {
    if (!this._e2eService.e2eConfig) {
      this._e2eService.getE2eConfig().subscribe(() => { });
    }
    if (this._e2eService.sRKeyVal) return;

    const isMultitabSignoff = sessionStorage.getItem('multitabSignoff');
    if (isMultitabSignoff) {
      this.backend.bizToken = "";
      this._e2eService.initE2e().subscribe(() => {});
    } else {
      this.backend.delete("logout", {}, {})
        .pipe(catchError((error) => from([{ error }])))
        .subscribe(() => {
          this.backend.bizToken = "";
          this._e2eService.initE2e().subscribe(() => {});
        });
    }
  }

  private validateAndNavigate(qParam: Params): void {
    const allowedSiteIds = ["plcn_staples","plcn_cat","plcn_brooksbrothers","ploc_wawa","plcn_kawa","plcn_officedepot","plcn_servicecentral","plcn_llbean","plcn_meijer","plcn_wfcc","plcn_cpay","plcn_ostk","plcn_dillards","plcn_tractorsupply","ploc_shell","plcn_brandsource","plcn_jewelry","ploc_sunoco","ploc_exxonmobil","plcn_goodyear","goodyear","plcn_drivecard","plcn_home","plcn_elecappl","plcn_bestbuy","plcn_homedepot","cacn_homedepot","plcn_syw","sears","plcn_cty","plcn_lincolnservices","plcn_service","plcn_toro","plcn_brp","plcn_costco","plcn_hnpe","plcn_hnps","plcn_american","plcn_macys","plcn_bloomingdales"];
    const allowedPages = ["signon","singlesignon","ssoauthorize","ssoauthenticate","ssologin","tyrewardssignon"];

    if (this.isBrowserSupportPage) {
      if (!qParam.siteId) {
        this.router.navigate(['**'], { skipLocationChange: true });
      } else {
        const paramsModified = { ...qParam, pageName: 'browser' };
        this._svcService.setParams(paramsModified);
        this._contentService.setParams(paramsModified);
      }
      return;
    }
    if (!qParam.siteId || !qParam.pageName) {
      this.router.navigate(['**'], { skipLocationChange: true });
      return;
    }
    this.siteId = qParam?.siteId?.toLowerCase();
    if (!allowedSiteIds.includes(this.siteId) || !allowedPages.includes(qParam?.pageName?.toLowerCase())) {
      this.router.navigate(['**'], { skipLocationChange: true });
    }
  }

  private subscribeToBrandingContent(qParam: Params, siteIdVar: string, brandIdVar: string): void {
    this._contentService.getBrandingContent().subscribe((data) => {
      this.handleBrandingData(data, siteIdVar, brandIdVar);
      if (this.isMilEsUsRoute(qParam)) {
        this.router.navigate(['**'], { skipLocationChange: true });
      }
    });
    if (this._contentService.getBusinessID()) {
      this._contentService.getModalContent("jCARDS_svc_cw_modals").subscribe(() => {});
    } else {
      console.warn('Skipping getModalContent(jCARDS_svc_cw_modals) due to invalid businessID.');
    }
  }

  private handleBrandingData(data: any, siteIdVar: string, brandIdVar: string): void {
    if (data == null) return;
    this.pageData = data.value ? data.value.content.CARDS : data.content.CARDS;
    if (!this.pageData) return;
    this.ifBookmarkEnabled = this.pageData.copy$$bookmark_enabled?.TEXT ?? false;
    console.log("-----------------------------");
    console.log(siteIdVar);
    console.log(brandIdVar);
    if (this.ifBookmarkEnabled === "true" && !this.isBrowserSupportPage) {
      this.loadScriptforBookmark(siteIdVar, brandIdVar);
    }
  }

  private isMilEsUsRoute(qParam: Params): boolean {
    if (this.pageData?.copy$$enable_MIL?.TEXT !== 'true') return false;
    if (!qParam?.langId || !qParam?.brandId || !qParam?.siteId) return false;
    return qParam.siteId.toLowerCase() === 'plcn_cpay'
      && qParam.brandId.toUpperCase() === 'MIL'
      && qParam.langId.toUpperCase() === 'ES_US';
  }

  private subscribeToSignOnLoaded(): void {
    this._svcService.isSignOnLoaded.subscribe((data) => {
      if (data === undefined || data === null) return;
      if (data && !this._isSsoAuthenticateRedirect) {
        this._renderer.removeChild(this, this.overlay.nativeElement);
      }
      if (data && this._isSywSignon && isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          this.popupModalService.openPopupContent.emit({
            popupContentComponent: "popup-site-syw-modal-redirect",
            popupContentParams: ""
          });
        }, 500);
      }
    });
  }  ngAfterViewInit() {
    this._contentService.componentLoaded.subscribe((data) => {
      this.loaded = data;
      this._changeDect.detectChanges();

      // Trigger existing DMAR GAM initialization after component is loaded
      if (data && isPlatformBrowser(this.platformId)) {
        // Delay to ensure all components are ready
        setTimeout(() => {
          console.log('Auto-triggering existing DMAR GAM initialization');
          this._dmarService.setup_listeners();
          this._dmarService.request_ads();
        }, 1000);
      }
    });
  }

  redirectToSignOn() {
    console.log("redirectToSignOn called.");
    const currentParams = this._route.snapshot.queryParams;
    const navigationParams = {
      pageName: 'signon',
      siteId: currentParams.siteId,
      langId: currentParams.langId
    };
    console.log("Navigating to /signon with queryParams:", navigationParams);
    this.router.navigate(['/signon'], {
      queryParams: navigationParams
    });
  }

  SSOAuthorizeSetup(processIndicator: string, siteId: string, token: string, cmp: any) {
    try {
      // Create the form dynamically
      const form = this.createForm();
      const windowId = this._svcService.getWindowId();
      sessionStorage.setItem('window_id', windowId);
      // Append required input fields to the form
      form.appendChild(this.createInput('channelId', 'MBOL'));
      form.appendChild(this.createInput('processIndicator', processIndicator));
      form.appendChild(this.createInput('siteId', siteId));
      form.appendChild(this.createInput('accessToken', token));
      form.appendChild(this.createInput('cmp', cmp));
      form.appendChild(this.createInput('windowId', windowId));

      // Append the form to the document body and submit it
      document.body.appendChild(form);

      try{
        form.submit();
      }
      catch (error) {
        this.redirectToSignOn();
        return
      }

    } catch (error) {
      console.error('Error in SSOAuthorizeSetup:', error);
    }
  }

  createForm() {
    const form = document.createElement('form');
    let action = '';

    // Use the environment.server.ts for the endpoint
    const endpoint = this._svcService.api?.endpoints['ssoauthorizesetup/action'];

    console.log('Endpoint for SSO Authorize Setup:', this._svcService.api);

    // Validate the endpoint

    // Check if the endpoint is defined in the environment configuration
    if (endpoint) {
      // Replace placeholders with actual values
      action = `${window.location.origin}${endpoint}`;
    } else {
      this.redirectToSignOn();
      return null; // If endpoint is not defined, redirect to signon
    }

    // Configure the form
    form.style.display = 'none';
    form.method = 'post'; // Use POST method for secure data transmission
    form.action = action; // Set the action URL
    return form;
  }

  createInput(key: string, value: any) {
    const input = document.createElement('input');
    input.type = 'hidden'; // Hidden input field
    input.name = key;
    input.id = key;
    input.value = value;
    return input;
  }

	public loadScriptforBookmark(siteIdArg, brandIdArg) {
    if (typeof window !== 'undefined') {
      var isIOSorAndroid = /android|iPhone/i.test(this.windowService.nativeWindow.navigator.userAgent);
      if(isIOSorAndroid){
        if(siteIdArg === "plcn_wfcc" && brandIdArg){
        var tags = document.createElement("script");
        }
        else  {
        var stylePartner= siteIdArg.split("_");
        stylePartner=stylePartner[stylePartner.length-1];
        var tags = document.createElement("script");
        }
        tags.async = true;
        tags.type = "text/javascript";
        document.getElementsByTagName("head")[0].appendChild(tags);

      var browserLanguage= this.windowService.nativeWindow.navigator.language;
        if(browserLanguage != undefined){
          browserLanguage=browserLanguage.toLowerCase();
          if(/en/i.test(browserLanguage)){
            browserLanguage="en";
          }else if(/es/i.test(browserLanguage)){
            browserLanguage="es";
          }else{
            browserLanguage = "en";
          }
        }else{
          browserLanguage = "en";
        }
        if(brandIdArg) {
          let dynamicScripts = [
            {name: 'apple-touch-icon', href : 'assets/manifests/'+brandIdArg+'/bookmark_icons/icon_152_ios.png', sizes: '152x152'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+brandIdArg+'/bookmark_icons/icon_120_ios.png', sizes: '120x120'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+brandIdArg+'/bookmark_icons/icon_76_ios.png', sizes: '76x76'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+brandIdArg+'/bookmark_icons/icon_60_ios.png', sizes: '60x60'}
          ];
          for (let i = 0; i < dynamicScripts.length; i++) {
            var link = document.createElement('link');
            link.rel = dynamicScripts[i].name;
            link.href = dynamicScripts[i].href;
            document.getElementsByTagName( "head" )[0].appendChild(link);
          }
        }
        else {
          let dynamicScripts = [
            {name: 'manifest', href: 'assets/manifests/'+stylePartner+'/lib/manifest.'+browserLanguage+'.json'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+stylePartner+'/bookmark_icons/icon_152_ios.png', sizes: '152x152'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+stylePartner+'/bookmark_icons/icon_120_ios.png', sizes: '120x120'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+stylePartner+'/bookmark_icons/icon_76_ios.png', sizes: '76x76'}
          ];
          for (let i = 0; i < dynamicScripts.length; i++) {
            var link = document.createElement('link');
            link.rel = dynamicScripts[i].name;
            link.href = dynamicScripts[i].href;
            document.getElementsByTagName( "head" )[0].appendChild(link);
          }
        }
      }
    }
  }

  getStyleName(siteId){
    siteId = siteId.toLowerCase();
      for (var j = 0; j < styleConfig.partnerEnv.length; j++) {
        if (siteId == styleConfig.partnerEnv[j].siteId.toLowerCase()) {
          return styleConfig.partnerEnv[j].styleName;
         }
      }
  }

  deleteCookies() {
    let cookiesArray = document.cookie;
    if (cookiesArray != null && cookiesArray != "" && cookiesArray != undefined) {
      // delete citi_authorization and activeSessionLoggedin in cookies
      document.cookie = "citi_authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.citibank.com";
      document.cookie = "activeSessionLoggedin=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.citibank.com";
    }
  }

  async fetchBrandingData() {
    this._contentService.getModalContent("jCARDS_svc_cw_sign_on")
    .subscribe((data) => {
      this.pageData = data.content.CARDS;
      console.log('Page Data:', this.pageData);
      console.log('CARDS:', this.pageData?.CARDS);
      this._changeDect.detectChanges();
    });
  }
}

